import React from "react";
import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";

export default function About() {
  return (
    <div>
      <Seo title="About" description="The PM Test was founded by Ramon Pasos, a property-management professional with more than 16 years of experience." />
      <section className="border-b-2 border-stone-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-8 py-16">
          <p className="font-mono-pm text-xs tracking-[0.25em] uppercase text-[#991B1B] mb-5">About The PM Test</p>
          <h1 className="font-serif-display text-4xl sm:text-5xl font-black leading-tight text-stone-900">
            Reviews written by someone who's actually run properties.
          </h1>
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-4 sm:px-8 py-14 pm-prose">
        <p>
          The PM Test was founded by <strong>Ramon Pasos</strong>, a property-management professional with more than
          <strong> 16 years of experience</strong> spanning residential, mobile-home-community, and commercial property management.
        </p>
        <p>
          That experience isn't theoretical. It's built from years of hands-on work with maintenance, HVAC, vendors,
          work orders, tenant relations, inspections, budgeting, documentation and property technology — the day-to-day
          reality of keeping properties running.
        </p>

        <div className="border-l-4 border-stone-900 bg-white p-6 my-8 not-prose">
          <p className="font-mono-pm text-xs tracking-widest uppercase text-[#991B1B] mb-3">Our Mission</p>
          <p className="font-serif-display text-2xl leading-snug text-stone-900">
            Most reviews tell property managers what features a product has. The PM Test asks whether those features
            actually work in real-world property operations.
          </p>
        </div>

        <h2>Why standardized scoring?</h2>
        <p>
          Every product we review is put through the same nine-category rubric and scored out of 100. That consistency
          is what makes our reviews and comparisons genuinely useful — you're comparing products on the same terms,
          judged by the same operational standards.
        </p>

        <h2>Independence</h2>
        <p>
          The PM Test may earn affiliate commissions, and we disclose that clearly. But affiliate relationships never
          influence our scores or recommendations. A product earns its verdict on merit — or it doesn't.
        </p>
      </section>

      <section className="max-w-4xl mx-auto px-4 sm:px-8 pb-16">
        <div className="bg-stone-900 text-white p-8 md:p-12">
          <h2 className="font-serif-display text-3xl font-bold">Run properties? Tell us your stack.</h2>
          <p className="text-stone-400 mt-3 max-w-xl">We build reviews around real operator experience. Share the tools you use, love and hate.</p>
          <Link to="/share-your-stack" className="inline-block mt-6 bg-[#CCFF00] text-stone-900 px-8 py-4 font-mono-pm font-bold text-sm tracking-widest uppercase hover:-translate-y-1 transition-transform duration-200">
            Share Your Stack →
          </Link>
        </div>
      </section>
    </div>
  );
}
